<template>
  <section class="loading-preparation">
    <div class="loading-content">
      <div
        v-if="showSpinner"
        class="loading-spinner"
        aria-hidden="true"
      />
      <h2 class="loading-title">
        {{ title }}
      </h2>
      <div class="loading-track">
        <div class="loading-bar" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LoadingPreparation',
  props: {
    title: {
      type: String,
      default: 'Aguarde enquanto preparamos o ambiente.'
    },
    showSpinner: {
      type: Boolean,
      default: false
    }
  },
  // Enquanto esta tela estiver visível ela é o único indicador de carregamento.
  // Sem isto o overlay global do Buefy (véu branco a 50% + spinner próprio)
  // aparece por cima sempre que uma action embrulhada em underLoadingFunction
  // roda em paralelo — dois loaders empilhados na mesma espera.
  created() {
    this.suppressGlobalLoading(true)
  },
  destroyed() {
    this.suppressGlobalLoading(false)
  },
  methods: {
    ...mapActions(['suppressGlobalLoading'])
  }
}
</script>

<style scoped lang="scss">
.loading-preparation {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.loading-content {
  width: 100%;
  max-width: 28rem;
  text-align: center;
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--biometric-text);
  margin-bottom: 1.25rem;
}

.loading-spinner {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1.25rem;
  border: 0.5rem solid var(--biometric-progress-track);
  border-top-color: var(--biometric-progress-fill);
  border-radius: 50%;
  animation: loading-spin 0.8s linear infinite;
}

.loading-track {
  width: 100%;
  height: 0.5rem;
  background-color: var(--biometric-progress-track);
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.loading-bar {
  position: absolute;
  top: 0;
  left: -35%;
  width: 35%;
  height: 100%;
  background: var(--biometric-progress-fill);
  border-radius: 999px;
  animation: loading-slide 1.1s ease-in-out infinite;
}

@keyframes loading-slide {
  0% {
    left: -35%;
  }
  100% {
    left: 100%;
  }
}

@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
